import React from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
export default function PrivacyPage() {
    return (
        <div>
            <Header />
            <Breadcrumb />
            <div className="legal-container">
                <h1>Privacy Policy</h1>
                <p>
                    Welcome to senthanamuthankidswear.shop. Your privacy is important to us.
                    This Privacy Policy explains how we collect, use, and protect your
                    information when you visit our website.
                </p>
                <section>
                    <h2>1. Information We Collect</h2>
                    <p><strong>Personal Information</strong></p>
                    <ul>
                        <li>Name, email address, phone number, shipping/billing address.</li>
                    </ul>
                    <p><strong>Payment Information</strong></p>
                    <ul>
                        <li>
                            Payment details are securely processed through third-party payment
                            gateways. We do not store your card details.
                        </li>
                    </ul>
                    <p><strong>Usage Data</strong></p>
                    <ul>
                        <li>
                            IP address, browser type, pages visited, and time spent on the website.
                        </li>
                    </ul>
                </section>
                <section>
                    <h2>2. How We Use Your Information</h2>
                    <ul>
                        <li>Process and deliver your orders</li>
                        <li>Improve our website and services</li>
                        <li>Communicate updates, offers, and promotions</li>
                        <li>Provide customer support</li>
                        <li>Prevent fraud and ensure security</li>
                    </ul>
                </section>
                <section>
                    <h2>3. Cookies</h2>
                    <ul>
                        <li>Enhance user experience</li>
                        <li>Remember preferences</li>
                        <li>Analyze website traffic</li>
                    </ul>
                    <p>You can disable cookies in your browser settings if you prefer.</p>
                </section>
                <section>
                    <h2>4. Sharing Your Information</h2>
                    <p>We do not sell or trade your personal information. We may share your data with:</p>
                    <ul>
                        <li>Payment gateways (for secure transactions)</li>
                        <li>Shipping partners (to deliver your orders)</li>
                        <li>Legal authorities (if required by law)</li>
                    </ul>
                </section>
                <section>
                    <h2>5. Data Security</h2>
                    <p>
                        We take appropriate measures to protect your personal data from
                        unauthorized access, alteration, or disclosure.
                    </p>
                </section>
                <section>
                    <h2>6. Third-Party Links</h2>
                    <p>
                        Our website may contain links to third-party websites. We are not
                        responsible for their privacy practices.
                    </p>
                </section>
                <section>
                    <h2>7. Your Rights</h2>
                    <ul>
                        <li>Access your personal data</li>
                        <li>Request correction or deletion</li>
                        <li>Withdraw consent for marketing</li>
                    </ul>
                    <p>
                        To do so, contact us at:
                        <br />
                        <strong>Email:</strong> senthanamuthankidwear@gmail.com
                    </p>
                </section>
                <section>
                    <h2>8. Children’s Privacy</h2>
                    <p>
                        We do not knowingly collect personal information from children under 13
                        without parental consent.
                    </p>
                </section>
                <section>
                    <h2>9. Changes to This Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. Changes will be
                        posted on this page.
                    </p>
                </section>
                <section>
                    <h2>10. Contact Us</h2>
                    <p>If you have any questions, contact us:</p>
                    <ul>
                        <li>Email: senthanamuthankidwear@gmail.com</li>
                        <li>Phone: 9360990836</li>
                        <li>Address: Saravanampatty, Coimbatore</li>
                    </ul>
                </section>
            </div>
            <Footer />
        </div>
    )
}
